import axios from 'axios'

export default class UserResource {
  login (code, password, digipass = '') {
    return axios.post('/api/auth/login', {
      code,
      password,
      digipass
    })
  }

  loginWithHash (personId, password) {
    return axios.post('/api/auth/login-with-hash', {
      user_id: personId,
      password: password
    })
  }

  user () {
    return axios.get('/api/auth/user')
  }

  logout () {
    return axios.get('/api/auth/logout')
  }

  resetPassword (personalId, mobile) {
    return axios.post('/api/auth/reset-password', {
      personal_id: personalId,
      mobile: mobile
    })
  }

  sendDigipass (code, password) {
    return axios.post('/api/auth/digipass', {
      code,
      password
    })
  }

  loadStudentData (studentId) {
    return axios.get(`/api/students/${studentId}`)
  }

  loadCurrentUserData () {
    return axios.get('/api/persons/me')
  }

  loadPersonData (personId) {
    return axios.get(`/api/persons/${personId}`)
  }

  getUploadedDocuments (type){
    return axios.get(`/api/persons/get-user-documents/`+ type)
  }
  
  deleteDocument(type,file){
    return axios.get(`/api/persons/delete-user-documents/`+ type + '/' + file)
  }

  updateStudentDetails (studentId, data = []) {
    return axios.patch(`/api/students/${studentId}`, { data })
  }

  genders () {
    return axios.get('/api/users/genders')
  }

  persons (page = 1, perPage = 20, filters = { }, sort = { }) {
    const filterString = new URLSearchParams(filters)
    const sortString = new URLSearchParams(sort)
    return axios.get(`/api/persons?page=${page}&per_page=${perPage}&${filterString}&${sortString}`)
  }

  academicalStatuses () {
    return axios.get('/api/academical-statuses')
  }

  updateMyProfile (data) {
    return axios.patch('/api/persons/me', data)
  }

  changePicture (formData) {
    return axios.post('/api/persons/me/picture', formData)
  }

  changePassword (data) {
    return axios.post('/api/persons/me/password', data)
  }

  uploadDiploma (formData) {
    return axios.post('/api/persons/me/diploma', formData)
  }

  uploadIdcard (formData) {
    return axios.post('/api/persons/me/id-card', formData)
  }

  uploadCv (formData) {
    return axios.post('/api/persons/me/cv', formData)
  }

  uploadResume (formData) {
    return axios.post('/api/persons/me/resume', formData)
  }

  uploadPublication (formData) {
    return axios.post('/api/persons/me/publication', formData)
  }

  uploadPension (formData) {
    return axios.post('/api/persons/me/pension', formData)
  }

  uploadResidence (formData) {
    return axios.post('/api/persons/me/residence', formData)
  }

  uploadConviction (formData) {
    return axios.post('/api/persons/me/conviction', formData)
  }

  uploadMedActivity (formData) {
    return axios.post('/api/persons/me/med-activity', formData)
  }
  
  education (personId) {
    return axios.get(`/api/persons/${personId}/education`)
  }

  workExperience (personId) {
    return axios.get(`/api/persons/${personId}/work-experience`)
  }

  contracts (personId) {
    return axios.get(`/api/persons/${personId}/contracts`)
  }

  schedule (personId) {
    return axios.get(`/api/persons/${personId}/schedule`)
  }

  countries(){
    return axios.get('/api/persons/getCountries')
  }

  eduTypes(){
    return axios.get('/api/persons/getEduTypes')
  }

  bios(){
    return axios.get('/api/persons/getBios')
  }

  positions(){
    return axios.get('/api/persons/getPositions')
  }

  activities(){
    return axios.get('/api/persons/getActivities')
  }

  languages(){
    return axios.get('/api/persons/getLanguages')
  }

  conferenceStatuses(){
    return axios.get('/api/persons/getConferenceStatuses')
  }

  conferenceTypes(){
    return axios.get('/api/persons/getConferenceTypes')
  }

  conferenceAttendenceTypes(){
    return axios.get('/api/persons/getConferenceAttendenceTypes')
  }

  awards(){
    return axios.get('/api/persons/getAwards')
  }

  pubTypes () {
    return axios.get('/api/persons/getPubTypes')
  }

  createPersonEducation (data) {
    return axios.post('/api/persons/create-person-education', data)
  }

  createWorkingExperience (data) {
    return axios.post('/api/persons/create-person-working-experience', data)
  }

  createScienceProject (data) {
    return axios.post('/api/persons/create-person-science-project', data)
  }

  createPatent (data) {
    return axios.post('/api/persons/create-person-patent', data)
  }

  createResearchArea (data) {
    return axios.post('/api/persons/create-person-research-area', data)
  }

  createLegalActivity(data) {
    return axios.post('/api/persons/create-person-legal-activity', data)
  }

  createCreativeActivity(data) {
    return axios.post('/api/persons/create-person-creative-activity', data)
  }

  createConference(data) {
    return axios.post('/api/persons/create-person-conference', data)
  }

  createAward(data) {
    return axios.post('/api/persons/create-person-award', data)
  }

  updateResume (data) {
    return axios.patch('/api/persons/update-person-resume', data)
  }


  downloadfile(file_name,doc_type){


    return axios.post('/api/persons/downloadfile',{file_name,doc_type},{responseType:'blob'})

  }

  workExperiences(){

    return axios.get('/api/work-experience')


  }

  user_levels(){

    return axios.get('/api/user_levels')

  }


  changeUserLevel(personID,user_levelID){

    return  axios.post('/api/changeUserLevel',{personID,user_levelID})


  }

}
